<template>
  <v-app id="auth_app">
    <v-container
        class="fill-height concrete"
        fluid
    >
      <v-content>
        <v-row
            align="center"
            justify="center"
        >
          <v-col
              cols="12"
              sm="12"
              md="4"
          >
            <router-view/>
          </v-col>
        </v-row>
      </v-content>
    </v-container>
    <v-footer class="concrete">
      <v-spacer></v-spacer>
      <div class="grey--text">&copy; ООО ИМПЕЛТЕХ, ИНН 7719856033</div>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'Auth',
  data: () => ({
    //
  }),
}
</script>